function getFunctionsFromType(_MBTI) {
    var stack = ["", ""];
    var firstFunction = "";
    var secondFunction = "";
    if (_MBTI.substring(0, 1) === "I") {
        if (_MBTI.substring(3) === "P") {
            firstFunction = _MBTI.substring(2, 3) + "i";
            secondFunction = _MBTI.substring(1, 2) + "e";
        } else {
            firstFunction = _MBTI.substring(1, 2) + "i";
            secondFunction = _MBTI.substring(2, 3) + "e";
        }
    } else {
        if (_MBTI.substring(3) === "J") {
            firstFunction = _MBTI.substring(2, 3) + "e";
            secondFunction = _MBTI.substring(1, 2) + "i";
        } else {
            firstFunction = _MBTI.substring(1, 2) + "e";
            secondFunction = _MBTI.substring(2, 3) + "i";
        }
    }
    stack[0] = firstFunction;
    stack[1] = secondFunction;
    return stack;
}

export { getFunctionsFromType }